import { CategoryRestrictions, MEMBERSHIP_STATE } from '../../graphql/types.generated';

export type Membership = {
  id: string;
  customerId: string;
  state: MEMBERSHIP_STATE;
  phone: string;
  email: string | null;
  firstName: string;
  lastName: string;
  birthdate: string | null;
  isCompleted: boolean;
  hasPasscode: boolean;
  hasEmail: boolean;

  points: number;

  customData: MembershipCustomData | null;
  programTermsAcceptanceAt: null | string;

  communicationPreference: {
    smsOptIn: boolean;
    pushOptIn: boolean;
  };

  primaryAddress: MembershipAddress | null;

  // values are undefined when fuelAndConvenienceProfile is not existing
  fuelAndConvenienceProfile: {
    restrictionVerification: CategoryRestrictions | null | undefined;
    pendingVerification: CategoryRestrictions | null | undefined;
    memberDataShare: boolean | null | undefined;
    preferredFuelProductGroup: MembershipPreferredFuelProductGroup | null | undefined;
  };

  homeStores: string[];
};

export interface MembershipConfigOverrides {
  walletEnabled?: boolean;
  payInsideEnabled?: boolean;
  payAtPumpEnabled?: boolean;
  deleteAccountEnabled?: boolean;
  appRatingEnabled?: boolean;
  productInterestsEnabled?: boolean;
  productInterestsEAIVPromotionOnProfileCompletedEnabled?: boolean;
  eaivAgeVerificationEnabled?: boolean;
  eaivIdentityVerificationEnabled?: boolean;
  freshdeskEnabled?: boolean;
  freshdeskWidgetId?: string;
  freshdeskWidgetToken?: string;
  freshdeskWidgetHost?: string;
  freshdeskWidgetSdkUrl?: string;
  promptIntervalDays?: number;
  transactionHistoryLookupDays?: number;
  totalAvailableRollbackEnabled?: boolean;
}

export interface MembershipCustomData {
  configOverrides?: MembershipConfigOverrides;
}

export interface MembershipAddress {
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
}

export enum MembershipDateTimeFormat {
  BirthdateDate = 'yyyy-MM-dd',
}

type MembershipPreferredFuelProductGroup = {
  id: string;
};

export { MEMBERSHIP_STATE };
